import { render, staticRenderFns } from "./OrderContent.vue?vue&type=template&id=0de53d53&scoped=true&"
import script from "./OrderContent.vue?vue&type=script&lang=ts&"
export * from "./OrderContent.vue?vue&type=script&lang=ts&"
import style0 from "./OrderContent.vue?vue&type=style&index=0&id=0de53d53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de53d53",
  null
  
)

export default component.exports